module.exports = __webpack_public_path__ + "img/bd(5).e8a87478.webp";